import { AtendimentoVacinacaoState, RegistroVacinacaoFormModel } from 'view/atendimentos/atendimento-vacinacao/model'
import { convertRegistrosVacinacaoQueryRetificacaoToForm } from 'view/atendimentos/atendimento-vacinacao/registros/converter'

import { AtendimentoVacinacaoRetificacaoModel } from './model-retificacaoAtendimento'
import { RetificacaoStorageModel } from './useJustificativaRetificacaoStorage'

export const initialValueRetificacaoVacinacao = (
  atendimentoVacinacaoRetificacao: AtendimentoVacinacaoRetificacaoModel,
  retificacaoStorage: RetificacaoStorageModel
): AtendimentoVacinacaoState => {
  const { vacinacao, finalizadoEm } = atendimentoVacinacaoRetificacao

  const registrosVacinacao: ReadonlyArray<RegistroVacinacaoFormModel> = convertRegistrosVacinacaoQueryRetificacaoToForm(
    vacinacao,
    finalizadoEm
  )

  return {
    condicoesVacinacao: {
      condicao: vacinacao.condicaoMaternal,
      comunicanteHanseniase: vacinacao.isComunicanteHanseniase,
      viajante: vacinacao.isViajante,
    },
    registroVacinacao: registrosVacinacao,
    finalizacaoVacinacao: {},
    retificacaoAtendimento: {
      justificativa: retificacaoStorage?.justificativa,
      historicoCabecalhoId: retificacaoStorage?.historicoCabecalhoId,
    },
  }
}
